import { PlotDatum } from 'plotly.js'
import _ from 'underscore'

import { formatForUnit } from 'helpers/formatters'

import { DeviceMaintenanceTrendGroup, DeviceMetric } from 'types/DeviceMetric'

export const parseTooltipData = (points: Array<PlotDatum>, metricAndGroupList: Array<DeviceMaintenanceTrendGroup | DeviceMetric>) => {
  const tooltipData: Array<{ color: string, value: string }> = []
  _.each(metricAndGroupList, (item) => {
    const processMetric = (metric, unit) => {
      const point = _.find(points, (point) => point.data.name === metric.name)
      tooltipData.push({
        color: metric.color,
        value: point?.y ? formatForUnit(point.y, unit) : 'Not Calculated'
      })
    }

    if ('metricId' in item) {
      processMetric(item, item.unit)
    } else {
      _.each(item.metrics, (metric) => processMetric(metric, item.unit))
    }
  })

  return tooltipData
}
